import type { FunctionComponent } from 'react'

import { FlowPage, H2 } from '@monthio/design-system'
import {
	AssetExpensesIntroExplainerIcon1,
	AssetExpensesIntroExplainerIcon2,
	AssetExpensesOverviewIcon,
} from '@monthio/icons'
import { useTranslation } from 'react-i18next'

import {
	ExplainerList,
	ExplainerListItem,
} from '../../../modulesTemp/general/FlowWizardUtils'

export const AssetExpensesIntro: FunctionComponent<{
	onCompleted: () => void
}> = ({ onCompleted }) => {
	const { t } = useTranslation()

	return (
		<FlowPage>
			<FlowPage.Content $spacing="xl">
				<FlowPage.Header
					title={t('assetExpenses-header-intro-title')}
					description={t('assetExpenses-header-intro-subtitle')}
					slot={<AssetExpensesOverviewIcon />}
				/>
				<div>
					<H2>{t('assetExpenses-intro-explainer-title')}</H2>
					<ExplainerList>
						<ExplainerListItem>
							<AssetExpensesIntroExplainerIcon1 width={24} height={24} />
							{t('asset-expenses-intro-explainer-1')}
						</ExplainerListItem>
						<ExplainerListItem>
							<AssetExpensesIntroExplainerIcon2 width={24} height={24} />
							{t('asset-expenses-intro-explainer-2')}
						</ExplainerListItem>
					</ExplainerList>
				</div>
			</FlowPage.Content>
			<FlowPage.Footer
				actions={
					<FlowPage.Cta onClick={onCompleted}>
						{t('assetExpenses-intro-button-start')}
					</FlowPage.Cta>
				}
			/>
		</FlowPage>
	)
}
